import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetEncodeSpecificationsLookupResponse } from "../../api/orders-api/encode-specification/responses/GetEncodeSpecificationsLookupResponse";
import { useEncodeSpecificationApi } from "../../api/orders-api/encode-specification/useEncodeSpecificationApi";
import { EncodeSpecification, mapToEncodeSpecification } from "../../types/EncodeSpecification";

interface IEncodeSpecificationsDataContext {
    encodeSpecifications: EncodeSpecification[];
    isLoading: boolean;
}

export const EncodeSpecificationsDataContext = createContext<IEncodeSpecificationsDataContext>({
    encodeSpecifications: [],
    isLoading: true
});

type EncodeSpecificationsDataProviderProps = React.PropsWithChildren<unknown>;

export const EncodeSpecificationsDataProvider: React.FunctionComponent<EncodeSpecificationsDataProviderProps> = ({
    children
}: EncodeSpecificationsDataProviderProps) => {
    const [encodeSpecifications, setEncodeSpecifications] = useState<EncodeSpecification[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getEncodeSpecificationsLookup } = useEncodeSpecificationApi();

    useEffect(() => {
        setIsLoading(true);

        getEncodeSpecificationsLookup()
            .then((response: GetEncodeSpecificationsLookupResponse) => {
                const newItems = response.items.map(mapToEncodeSpecification);
                const sortedItems = getSortedCollection(newItems, "name");

                setEncodeSpecifications(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <EncodeSpecificationsDataContext.Provider value={{ encodeSpecifications, isLoading }}>
            {children}
        </EncodeSpecificationsDataContext.Provider>
    );
};
